try {

	// $ = window.$ = window.jQuery = require( 'admin-lte/plugins/jquery/jquery.min' );
	window.$ = window.jQuery = require('jquery');

	// Framework UIkit
	window.UIkit = require('uikit');
	let Icons = require('uikit/dist/js/uikit-icons');
	UIkit.use(Icons);
	
	require( 'admin-lte/plugins/bootstrap/js/bootstrap.bundle.min' );
	
	require( 'admin-lte' );
	
	window.moment = require( 'moment' );
	moment.locale('es');

	// require( './components/bootstrap-datepicker' );

	require( 'admin-lte/plugins/select2/js/select2.min' );

	/**
     * Libreria para validaciones
     *
     * https://validatejs.org/
     */
	window.SlimSelect = require("validate.js");
	
	// Components
    require('./components/pikaday');

} catch ( e ) { }
